<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>

        <b-container>
            <!-- Botón Crear Grupo -->
            <b-row class="mb-4 justify-content-end">
                <b-col md="auto">
                    <b-button @click="mostrarModalCrear" size="lg" variant="outline-primary">
                        <b-icon icon="plus-circle" class="me-2"></b-icon>
                        {{ labels.createGroup }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Buscadores -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="8">
                    <b-row class="align-items-end">
                        <b-col md="4">
                            <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">
                                {{ labels.searchByInterco }}
                            </label>
                            <b-form-input v-model="searchInterco" @input="searchOnTableInterco" class="form-control"
                                placeholder="Buscar por interco...">
                            </b-form-input>
                        </b-col>

                        <b-col md="4">
                            <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">
                                {{ labels.searchByDescription }}
                            </label>
                            <b-form-input v-model="searchDescripcion" @input="searchOnTableDescripcion"
                                class="form-control" placeholder="Buscar por descripción...">
                            </b-form-input>
                        </b-col>

                        <b-col md="4" class="d-flex align-items-end">
                            <b-button @click="borraCriterio" variant="outline-secondary" class="w-100"
                                style="height: 38px;">
                                <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                                {{ labels.clear }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <!-- Contador -->
            <b-row class="mb-3 justify-content-center">
                <b-col md="6">
                    <div class="text-muted text-center">
                        {{ labels.showing }} <strong>{{ visibleItems.length }}</strong> {{ labels.of }}
                        <strong>{{ listGruposIntercos.length }}</strong> {{ labels.records }}
                    </div>
                </b-col>
            </b-row>

            <!-- Tabla de Grupos Intercos -->
            <b-row class="justify-content-center">
                <b-col md="8">
                    <div class="table-responsive">
                        <table class="table table-hover table-bordered mb-2">
                            <thead style="background-color: #4a90e2;">
                                <tr>
                                    <th scope="col" class="text-center text-white border-0"
                                        style="font-weight: 600; width: 120px;">
                                        Interco</th>
                                    <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">
                                        Descripción</th>
                                    <th scope="col" class="text-center text-white border-0"
                                        style="font-weight: 600; width: 150px;">
                                        Cuentas Asociadas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="grupo in visibleItems" :key="grupo.id" @click="editarGrupo(grupo)"
                                    class="clickable-row" style="cursor: pointer;">
                                    <td class="text-center" style="width: 120px;">
                                        <strong class="text-dark">{{ grupo.interco }}</strong>
                                    </td>
                                    <td class="text-center">{{ grupo.descripcion }}</td>
                                    <td class="text-center">
                                        <b-badge variant="info"
                                            v-if="grupo.cuentasAsociadas && grupo.cuentasAsociadas.length > 0">
                                            {{ grupo.cuentasAsociadas.length }} cuenta(s)
                                        </b-badge>
                                        <b-badge variant="secondary" v-else>
                                            Sin cuentas
                                        </b-badge>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-col>
            </b-row>

            <!-- Mensaje cuando no hay datos -->
            <div v-if="listGruposIntercos.length === 0" class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>
        </b-container>

        <!-- Loading Spinner -->
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner variant="primary"></b-spinner>
        </div>

        <!-- Modal para Crear/Editar Grupo -->
        <b-modal v-model="showModal" :title="modoEdicion ? labels.editGroup : labels.createGroup" size="xl" hide-footer
            scrollable>
            <b-form @submit.prevent="guardarGrupo">
                <b-row>
                    <b-col md="6">
                        <b-form-group :label="labels.interco" label-class="fw-bold">
                            <b-form-input type="number" v-model="formulario.interco" required
                                :placeholder="labels.enterInterco"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group :label="labels.description" label-class="fw-bold">
                            <b-form-input v-model="formulario.descripcion" required :maxlength="60"
                                :placeholder="labels.enterDescription"></b-form-input>
                            <small class="text-muted">{{ formulario.descripcion.length }}/60 {{
                                labels.characters }}</small>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Nueva sección para seleccionar cuentas por compañía -->
                <b-row class="mt-4">
                    <b-col md="12">
                        <b-card :header="labels.assignAccounts" header-class="fw-bold bg-light">
                            <b-alert variant="info" show class="mb-3">
                                <b-icon icon="info-circle" class="me-2"></b-icon>
                                {{ labels.accountSelectionHelp }}
                            </b-alert>

                            <!-- Filtro de Compañías -->
                            <b-form-group :label="labels.selectCompany" label-class="fw-bold">
                                <b-form-select v-model="companiaSeleccionada" @change="cargarCuentasPorCompania"
                                    :options="companiasOptions" :disabled="isLoadingCuentas || companias.length === 0">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>
                                            {{ companias.length === 0 ? labels.loadingCompanies :
                                            labels.selectCompanyOption }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>

                            <b-form-group :label="labels.vigency" label-class="fw-bold" v-if="companiaSeleccionada">
                                <b-form-select v-model="vigenciaSeleccionada" @change="cargarCuentasPorCompania"
                                    :options="vigenciasOptions" :disabled="isLoadingCuentas || vigencias.length === 0">
                                    <template #first v-if="vigencias.length === 0">
                                        <b-form-select-option :value="null" disabled>
                                            {{ labels.noVigenciesAvailable }}
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                                <small class="text-muted" v-if="vigencias.length > 0">
                                    {{ vigencias.length }} {{ labels.vigenciesAvailable }}
                                </small>
                            </b-form-group>

                            <!-- Buscador de cuentas -->
                            <b-form-group :label="labels.searchAccount" label-class="fw-bold"
                                v-if="companiaSeleccionada && cuentasFiltradas.length > 0">
                                <b-input-group>
                                    <b-form-input v-model="searchCuenta" :placeholder="labels.searchAccountPlaceholder"
                                        @input="filtrarCuentas"></b-form-input>
                                    <b-input-group-append>
                                        <b-button variant="outline-secondary"
                                            @click="searchCuenta = ''; filtrarCuentas()">
                                            <b-icon icon="x"></b-icon>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                            <!-- Lista de cuentas seleccionables -->
                            <div v-if="companiaSeleccionada && cuentasDisponibles.length > 0" class="mt-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">{{ labels.availableAccounts }}</h6>
                                    <small class="text-muted">
                                        {{ labels.selected }}: {{ cuentasSeleccionadas.length }}
                                    </small>
                                </div>

                                <div class="cuentas-container" style="max-height: 300px; overflow-y: auto;">
                                    <b-list-group>
                                        <b-list-group-item v-for="cuenta in cuentasFiltradas" :key="cuenta.id"
                                            class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <b-form-checkbox v-model="cuentasSeleccionadas" :value="cuenta.id">
                                                    <span class="ml-2">
                                                        <strong>{{ cuenta.codigo }}</strong> - {{ cuenta.nombre }}
                                                    </span>
                                                </b-form-checkbox>
                                            </div>
                                            <small class="text-muted">{{ cuenta.compania_nombre }}</small>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>

                                <div v-if="cuentasFiltradas.length === 0" class="text-center py-3">
                                    <b-icon icon="search" font-scale="1.5"></b-icon>
                                    <p class="mt-2">{{ labels.noAccountsFound }}</p>
                                </div>
                            </div>

                            <!-- Cuentas ya seleccionadas (resumen) -->
                            <div v-if="cuentasSeleccionadas.length > 0" class="mt-4">
                                <h6 class="fw-bold">{{ labels.selectedAccounts }}</h6>
                                <div class="selected-accounts-container">
                                    <b-list-group>
                                        <b-list-group-item v-for="cuentaId in cuentasSeleccionadas" :key="cuentaId"
                                            class="py-2">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <strong>{{ obtenerCuentaPorId(cuentaId)?.codigo }}</strong>
                                                    - {{ obtenerCuentaPorId(cuentaId)?.nombre }}
                                                    <small class="text-muted ml-2">
                                                        ({{ obtenerCuentaPorId(cuentaId)?.compania_nombre }})
                                                    </small>
                                                </div>
                                                <b-button size="sm" variant="outline-danger"
                                                    @click="removerCuentaSeleccionada(cuentaId)">
                                                    <b-icon icon="x"></b-icon>
                                                </b-button>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>

                            <div v-if="!companiaSeleccionada" class="text-center py-4 text-muted">
                                <b-icon icon="building" font-scale="2"></b-icon>
                                <p class="mt-2">{{ labels.selectCompanyFirst }}</p>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <b-col md="12" class="d-flex justify-content-between">
                        <b-button v-if="modoEdicion" @click="eliminarGrupo(formulario.id)" variant="danger"
                            class="px-4">
                            <b-icon icon="trash" class="me-2"></b-icon>
                            {{ labels.delete }}
                        </b-button>
                        <div v-else></div>

                        <div>
                            <b-button type="button" variant="secondary" @click="cerrarModal" class="me-2 px-4">
                                {{ labels.cancel }}
                            </b-button>
                            <b-button type="submit" variant="primary" class="px-4" :disabled="isLoading">
                                <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
                                {{ modoEdicion ? labels.update : labels.save }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import GruposIntercosService from "@/services/GruposIntercos"
import CompanyService from "@/services/Company"
import PlanCuentasService from "@/services/PlanCuentas"

const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByInterco = (items, term) => {
    if (term) {
        return items.filter((item) =>
            toLower(item.interco).includes(toLower(term))
        );
    }
    return items;
};

const searchByDescripcion = (items, term) => {
    if (term) {
        const termLower = toLower(term);
        return items.filter((item) =>
            toLower(item.descripcion).includes(termLower)
        );
    }
    return items;
};

export default {
    name: "GruposIntercos",

    data: () => ({
        isLoading: false,
        isLoadingCuentas: false,
        showModal: false,
        modoEdicion: false,
        searchInterco: '',
        searchDescripcion: '',
        searchCuenta: '',
        listGruposIntercos: [],
        listGruposIntercosOrigen: [],
        
        // Datos para selección de cuentas
        companias: [],
        companiaSeleccionada: null,
        vigenciaSeleccionada: new Date().getFullYear(), // Vigencia actual por defecto
        vigencias: [],
        cuentasDisponibles: [],
        cuentasSeleccionadas: [],
        
        formulario: {
            id: null,
            interco: null,
            descripcion: '',
            u_crea: 1,
            createdAt: null,
            u_modifica: 1,
            updatedAt: null
        },
        itemLimit: 100,
        visibleItems: [],
        limitOptions: [
            { value: 100, text: '100 registros' },
            { value: 200, text: '200 registros' },
            { value: 500, text: '500 registros' },
            { value: 0, text: 'Mostrar todo' }
        ]
    }),

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Gestión de Grupos Intercos",
                    createGroup: "Crear Grupo",
                    editGroup: "Editar Grupo",
                    searchByInterco: "Buscar por Interco",
                    searchByDescription: "Buscar por Descripción",
                    interco: "Interco",
                    description: "Descripción",
                    enterInterco: "Ingrese el número de interco",
                    enterDescription: "Ingrese la descripción",
                    characters: "caracteres",
                    cancel: "Cancelar",
                    save: "Guardar",
                    update: "Actualizar",
                    delete: "Eliminar",
                    clear: "Limpiar",
                    showing: "Mostrando",
                    of: "de",
                    records: "registros",
                    noData: "No hay datos para mostrar",
                    actions: "Acciones",
                    
                    // Nuevas etiquetas para cuentas
                    assignAccounts: "Asignar Cuentas al Grupo",
                    accountSelectionHelp: "Seleccione una compañía y luego las cuentas que desea asociar a este grupo interco. Estas cuentas se marcarán automáticamente en el plan de cuentas.",
                    selectCompany: "Seleccionar Compañía",
                    selectCompanyOption: "-- Seleccione una compañía --",
                    vigency: "Vigencia",
                    searchAccount: "Buscar Cuenta",
                    searchAccountPlaceholder: "Buscar por código o nombre...",
                    availableAccounts: "Cuentas Disponibles",
                    selected: "Seleccionadas",
                    selectedAccounts: "Cuentas Seleccionadas",
                    selectCompanyFirst: "Seleccione una compañía para ver las cuentas disponibles",
                    noAccountsFound: "No se encontraron cuentas con ese criterio",
                    remove: "Remover",
                    loadingCompanies: "Cargando compañías...",
                    noVigenciesAvailable: "No hay vigencias disponibles",
                    vigenciesAvailable: "vigencias disponibles",
                }
            } else {
                return {
                    title: "Intercos Groups Management",
                    createGroup: "Create Group",
                    editGroup: "Edit Group",
                    searchByInterco: "Search by Interco",
                    searchByDescription: "Search by Description",
                    interco: "Interco",
                    description: "Description",
                    enterInterco: "Enter interco number",
                    enterDescription: "Enter description",
                    characters: "characters",
                    cancel: "Cancel",
                    save: "Save",
                    update: "Update",
                    delete: "Delete",
                    clear: "Clear",
                    showing: "Showing",
                    of: "of",
                    records: "records",
                    noData: "No data to display",
                    actions: "Actions",
                    
                    assignAccounts: "Assign Accounts to Group",
                    accountSelectionHelp: "Select a company and then the accounts you want to associate with this interco group. These accounts will be automatically marked in the chart of accounts.",
                    selectCompany: "Select Company",
                    selectCompanyOption: "-- Select a company --",
                    vigency: "Vigency",
                    searchAccount: "Search Account",
                    searchAccountPlaceholder: "Search by code or name...",
                    availableAccounts: "Available Accounts",
                    selected: "Selected",
                    selectedAccounts: "Selected Accounts",
                    selectCompanyFirst: "Select a company to see available accounts",
                    noAccountsFound: "No accounts found with that criteria",
                    remove: "Remove",
                    loadingCompanies: "Loading companies...",
                    noVigenciesAvailable: "No vigencies available",
                    vigenciesAvailable: "vigencies available",
                }
            }
        },
        
        companiasOptions() {
            console.log('Compañías disponibles:', this.companias);
            return this.companias.map(compania => ({
                value: compania.id,
                text: compania.nombre || compania.nombre_compania || 'Sin nombre'
            }));
        },

        vigenciasOptions() {
            console.log('Vigencias para options:', this.vigencias);

            if (!this.vigencias || this.vigencias.length === 0) {
                return [{ value: null, text: this.labels.noVigenciesAvailable, disabled: true }];
            }

            return this.vigencias.map(vigencia => ({
                value: vigencia.vigencia,
                text: vigencia.vigencia ? vigencia.vigencia.toString() : 'Sin vigencia'
            }));
        },
        
        cuentasFiltradas() {
            if (!this.searchCuenta) {
                return this.cuentasDisponibles;
            }
            const searchTerm = toLower(this.searchCuenta);
            return this.cuentasDisponibles.filter(cuenta => 
                toLower(cuenta.codigo).includes(searchTerm) || 
                toLower(cuenta.nombre).includes(searchTerm)
            );
        }
    },

    methods: {
        async cargarGrupos() {
            this.isLoading = true;
            try {
                const response = await GruposIntercosService.getAllGruposIntercos();
                this.listGruposIntercos = response.data.gruposIntercos;
                
                // Cargar cuentas asociadas para cada grupo
                for (let grupo of this.listGruposIntercos) {
                    try {
                        const cuentasResponse = await GruposIntercosService.getCuentasPorGrupoInterco(grupo.id);
                        grupo.cuentasAsociadas = cuentasResponse.data.cuentas || [];
                    } catch (error) {
                        console.error('Error cargando cuentas del grupo:', error);
                        grupo.cuentasAsociadas = [];
                    }
                }
                
                this.listGruposIntercosOrigen = [...this.listGruposIntercos];
                this.resetVisibleItems();
            } catch (error) {
                console.error('Error cargando grupos:', error);
            } finally {
                this.isLoading = false;
            }
        },
        
        async cargarCompanias() {
            try {
                const response = await CompanyService.getAllCompanies();
                console.log('Respuesta completa de compañías:', response);

                // Diferentes posibles estructuras de respuesta
                if (response.data && response.data.companies) {
                    this.companias = response.data.companies;
                } else if (response.data && Array.isArray(response.data)) {
                    this.companias = response.data;
                } else if (response.data && response.data.data) {
                    this.companias = response.data.data;
                } else {
                    this.companias = [];
                }

                console.log('Compañías procesadas:', this.companias);
            } catch (error) {
                console.error('Error cargando compañías:', error);
                this.companias = [];
            }
        },
        
        async cargarVigencias() {
            try {
                const response = await PlanCuentasService.getVigenciaPlancuentas();
                console.log('Respuesta de vigencias:', response);

                // Verifica la estructura de la respuesta
                if (response.data && response.data.vigencias) {
                    this.vigencias = response.data.vigencias;
                } else if (response.data && Array.isArray(response.data)) {
                    this.vigencias = response.data;
                } else if (response.data && response.data.data) {
                    this.vigencias = response.data.data;
                } else {
                    this.vigencias = [];
                }

                console.log('Vigencias procesadas:', this.vigencias);

                // Ordenar vigencias de más reciente a más antigua
                this.vigencias.sort((a, b) => b.vigencia - a.vigencia);

                // Establecer vigencia seleccionada si hay datos
                if (this.vigencias.length > 0) {
                    this.vigenciaSeleccionada = this.vigencias[0].vigencia;
                    console.log('Vigencia seleccionada por defecto:', this.vigenciaSeleccionada);
                }
            } catch (error) {
                console.error('Error cargando vigencias:', error);
                this.vigencias = [];
                // Datos de prueba en caso de error
                const currentYear = new Date().getFullYear();
                this.vigencias = [
                    { vigencia: currentYear },
                    { vigencia: currentYear - 1 },
                    { vigencia: currentYear - 2 }
                ];
                this.vigenciaSeleccionada = currentYear;
            }
        },

        async cargarCuentasPorCompania() {
            console.log('cargarCuentasPorCompania llamado con:', {
                compania: this.companiaSeleccionada,
                vigencia: this.vigenciaSeleccionada
            });

            if (!this.companiaSeleccionada) {
                console.log('No hay compañía seleccionada');
                this.cuentasDisponibles = [];
                return;
            }

            if (!this.vigenciaSeleccionada) {
                console.log('No hay vigencia seleccionada');
                this.cuentasDisponibles = [];
                return;
            }

            this.isLoadingCuentas = true;
            try {
                console.log('Llamando a planCuentPorCompaVig con:', this.companiaSeleccionada, this.vigenciaSeleccionada);

                const response = await PlanCuentasService.planCuentPorCompaVig(
                    this.companiaSeleccionada,
                    this.vigenciaSeleccionada
                );

                console.log('Respuesta de cuentas:', response);

                if (response.data && response.data.planCuentas) {
                    this.cuentasDisponibles = response.data.planCuentas;
                } else if (response.data && Array.isArray(response.data)) {
                    this.cuentasDisponibles = response.data;
                } else {
                    this.cuentasDisponibles = [];
                }

                console.log('Cuentas disponibles procesadas:', this.cuentasDisponibles.length);

                // Obtener nombre de la compañía para mostrar
                const compania = this.companias.find(c => c.id === this.companiaSeleccionada);
                if (compania) {
                    this.cuentasDisponibles = this.cuentasDisponibles.map(cuenta => ({
                        ...cuenta,
                        compania_nombre: compania.nombre || 'Sin nombre'
                    }));
                }

            } catch (error) {
                console.error('Error cargando cuentas:', error);
                console.error('Detalles del error:', error.response || error.message);
                this.cuentasDisponibles = [];
                // Datos de prueba
                this.cuentasDisponibles = [
                    { id: 1, codigo: '110505', nombre: 'Caja General', compania_nombre: 'Compañía Demo' },
                    { id: 2, codigo: '111005', nombre: 'Bancos', compania_nombre: 'Compañía Demo' },
                    { id: 3, codigo: '130505', nombre: 'Clientes', compania_nombre: 'Compañía Demo' }
                ];
            } finally {
                this.isLoadingCuentas = false;
            }
        },
        
        filtrarCuentas() {
            // La lógica de filtrado se maneja en la computed property cuentasFiltradas
        },
        
        removerCuentaSeleccionada(cuentaId) {
            this.cuentasSeleccionadas = this.cuentasSeleccionadas.filter(id => id !== cuentaId);
        },
        
        obtenerCuentaPorId(cuentaId) {
            return this.cuentasDisponibles.find(c => c.id === cuentaId);
        },

        mostrarModalCrear() {
            this.modoEdicion = false;
            this.resetFormulario();
            this.resetSeleccionCuentas();
            this.showModal = true;
        },

        async editarGrupo(grupo) {
            this.modoEdicion = true;
            this.formulario = { ...grupo };
            
            // Cargar cuentas asociadas al grupo
            this.isLoading = true;
            try {
                const cuentasResponse = await GruposIntercosService.getCuentasPorGrupoInterco(grupo.id);
                this.cuentasSeleccionadas = cuentasResponse.data.cuentas.map(c => c.id_plan_cuenta) || [];
                
                // Si hay cuentas seleccionadas, cargar la primera compañía para referencia
                if (this.cuentasSeleccionadas.length > 0 && cuentasResponse.data.cuentas[0]) {
                    this.companiaSeleccionada = cuentasResponse.data.cuentas[0].id_compania;
                    this.cargarCuentasPorCompania();
                }
            } catch (error) {
                console.error('Error cargando cuentas del grupo:', error);
                this.cuentasSeleccionadas = [];
            } finally {
                this.isLoading = false;
            }
            
            this.showModal = true;
        },

        async guardarGrupo() {
            this.isLoading = true;
            try {
                const userId = this.$store.state.userId || 1; 

                const formData = {
                    interco: this.formulario.interco,
                    descripcion: this.formulario.descripcion,
                    userId: userId,
                    cuentas: this.cuentasSeleccionadas // Agregar las cuentas seleccionadas
                };

                if (this.modoEdicion) {
                    formData.id = this.formulario.id;
                }

                console.log('Enviando datos:', formData);

                // Primero guardar/actualizar el grupo
                let grupoResponse;
                if (this.modoEdicion) {
                    grupoResponse = await GruposIntercosService.updateGrupoInterco(formData);
                } else {
                    grupoResponse = await GruposIntercosService.createGrupoInterco(formData);
                }
                
                const grupoId = grupoResponse.data.id || this.formulario.id;
                
                // Luego asignar las cuentas al grupo
                if (this.cuentasSeleccionadas.length > 0) {
                    const asignacionData = {
                        id_grupo_interco: grupoId,
                        cuentas: this.cuentasSeleccionadas,
                        userId: userId
                    };
                    
                    await GruposIntercosService.asignarCuentasAGrupo(asignacionData);
                }

                this.cerrarModal();
                this.cargarGrupos();

            } catch (error) {
                console.error('Error guardando grupo:', error);
                if (error.response && error.response.data) {
                    alert('Error: ' + error.response.data.message);
                } else {
                    alert('Error al guardar el grupo');
                }
            } finally {
                this.isLoading = false;
            }
        },

        async eliminarGrupo(id) {
            if (confirm('¿Está seguro de eliminar este grupo?')) {
                this.isLoading = true;
                try {
                    await GruposIntercosService.deleteGrupoInterco(id);
                    this.cerrarModal();
                    this.cargarGrupos();
                } catch (error) {
                    console.error('Error eliminando grupo:', error);
                } finally {
                    this.isLoading = false;
                }
            }
        },

        cerrarModal() {
            this.showModal = false;
            this.resetFormulario();
            this.resetSeleccionCuentas();
        },

        resetFormulario() {
            this.formulario = {
                id: null,
                interco: null,
                descripcion: '',
                u_crea: 1,
                createdAt: null,
                u_modifica: 1,
                updatedAt: null
            };
        },
        
        resetSeleccionCuentas() {
            this.companiaSeleccionada = null;
            this.vigenciaSeleccionada = new Date().getFullYear();
            this.cuentasDisponibles = [];
            this.cuentasSeleccionadas = [];
            this.searchCuenta = '';
        },

        borraCriterio() {
            this.searchInterco = '';
            this.searchDescripcion = '';
            this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            this.resetVisibleItems();
        },

        searchOnTableInterco() {
            this.listGruposIntercos = searchByInterco(this.listGruposIntercosOrigen, this.searchInterco);
            if (this.searchInterco === '') {
                this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            }
            this.resetVisibleItems();
        },

        searchOnTableDescripcion() {
            this.listGruposIntercos = searchByDescripcion(this.listGruposIntercosOrigen, this.searchDescripcion);
            if (this.searchDescripcion === '') {
                this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            }
            this.resetVisibleItems();
        },

        resetVisibleItems() {
            if (this.itemLimit === 0) {
                this.visibleItems = [...this.listGruposIntercos];
            } else {
                this.visibleItems = this.listGruposIntercos.slice(0, this.itemLimit);
            }
        },

        formatoFecha(fecha) {
            return new Date(fecha).toLocaleDateString('es-ES');
        }
    },

    async mounted() {
        this.isLoading = true;
        console.log('Iniciando carga de datos...');

        try {
            // Cargar compañías primero
            console.log('Cargando compañías...');
            await this.cargarCompanias();

            // Cargar vigencias segundo
            console.log('Cargando vigencias...');
            await this.cargarVigencias();

            // Cargar grupos intercos
            console.log('Cargando grupos intercos...');
            await this.cargarGrupos();

            console.log('Todos los datos cargados exitosamente');
        } catch (error) {
            console.error('Error en mounted:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
</script>

<style src="@/components/main.css"></style>

<style scoped>
.cuentas-container {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    padding: 10px;
}

.selected-accounts-container {
    max-height: 200px;
    overflow-y: auto;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}
</style>